var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.resolveLayout,{tag:"component"},[_c('router-view'),_c('Snackbar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }